<template>
  <div id="app">
    <loading ref="loading" />

    <transition 
      name="page"
      mode="out-in"
    >
      <component 
        :is="layout" 
        v-if="layout"
      />
    </transition>
  </div>
</template>

<script>
import Loading from '@/components/Loading'

export default {
  components: {
    Loading,
    BasicLayout: () => import('@/components/layout/basic'),
    MainLayout: () => import('@/components/layout/default'),
  },
  computed: {
    layout () {
      return this.$store.getters['layout/layout']
    }
  },
  
  metaInfo () {
    const appName = process.env.VUE_APP_TITLE
    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  mounted () {
    this.$store.loading = this.$refs.loading
  }
}
</script>
<style lang="sass">
  @import '@/assets/scss/app.scss'
</style>
